import React from "react";
import "./index.scss";
export default function CheckBox(props) {
  const { checked, handleChecked } = props;
  return (
    <div className="check-box">
      <div
        className={checked ? "checkbox-div checked" : "checkbox-div"}
        onClick={handleChecked}
      >
        {checked && (
          <svg
            width="8"
            height="6"
            viewBox="0 0 8 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.70711 2.29289C1.31658 1.90237 0.683418 1.90237 0.292893 2.29289C-0.0976311 2.68342 -0.0976311 3.31658 0.292893 3.70711L2.29289 5.70711C2.68342 6.09763 3.31658 6.09763 3.70711 5.70711L7.70711 1.70711C8.09763 1.31658 8.09763 0.683418 7.70711 0.292893C7.31658 -0.0976311 6.68342 -0.0976311 6.29289 0.292893L3 3.58579L1.70711 2.29289Z"
              fill="black"
            />
          </svg>

          //   <img src={CheckBoxTick} alt="checkbox tick" onClick={handleChecked} />
        )}
      </div>
    </div>
  );
}
